var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpacePersonal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.4158 45.8663C50.9158 45.8663 57.7327 38.9653 57.7327 30.5494C57.7327 22.1336 50.9158 15.1484 42.4158 15.1484C33.9158 15.1484 27.099 22.0494 27.099 30.4653C27.099 38.8811 33.9158 45.8663 42.4158 45.8663ZM42.4158 19.188C48.6436 19.188 53.6931 24.2375 53.6931 30.4653C53.6931 36.693 48.6436 41.7425 42.4158 41.7425C36.1881 41.7425 31.1386 36.7772 31.1386 30.5494C31.1386 24.3217 36.1881 19.188 42.4158 19.188Z",
    fill: "#27509F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8218 69.8516H69.1782C70.2723 69.8516 71.198 68.9259 71.198 67.8318C71.198 57.2279 62.5297 48.5596 51.9258 48.5596H33.0743C22.4703 48.5596 13.802 57.2279 13.802 67.8318C13.802 68.9259 14.7277 69.8516 15.8218 69.8516ZM33.0743 52.5992H51.9258C59.6683 52.5992 65.9802 58.3219 66.9901 65.812H18.0099C19.0198 58.3219 25.3317 52.5992 33.0743 52.5992Z",
    fill: "#27509F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpacePersonal);
export default __webpack_public_path__ + "static/media/space-personal.cefa7495ec57e3012d927c76496fbcdb.svg";
export { ForwardRef as ReactComponent };